var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { BreakpointsProvider, defaultBreakpoints } from './BreakpointsProvider';
import { processPropertiesForState, handleDimensionEvent } from './helpers/breakpointsSize';
import merge from 'lodash.merge';
/** `Breakpoints` component is used for setting s, m, & l widths for responsive layouts. Uses _context_ to provide components nested within (like `Col` & `On`) with breakpoint sizes */
var Breakpoints = /** @class */ (function (_super) {
    __extends(Breakpoints, _super);
    function Breakpoints() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // entire state object is passed to provider
        _this.state = defaultBreakpoints;
        _this.handleDimensionEvent = handleDimensionEvent.bind(_this)();
        _this.getCurrentBreakpoints = function () {
            var _a = _this.state, s = _a.s, m = _a.m, l = _a.l, xl = _a.xl;
            return {
                s: s,
                m: m,
                l: l,
                xl: xl,
                ssrSize: _this.props.ssrSize
            };
        };
        return _this;
    }
    Breakpoints.getDerivedStateFromProps = function (props, state) {
        var s = props.s, m = props.m, l = props.l, xl = props.xl, ssrSize = props.ssrSize;
        var breakpoints = merge(defaultBreakpoints, { s: s, m: m, l: l, xl: xl, ssrSize: ssrSize });
        return __assign(__assign(__assign({}, state), breakpoints), processPropertiesForState(breakpoints));
    };
    Breakpoints.prototype.componentDidMount = function () {
        if (this.handleDimensionEvent.eventAvailable) {
            this.handleDimensionEvent.addDimensionEventListener();
        }
        // fire resize event for SSR sync
        if (typeof document !== 'undefined' &&
            document.createEvent &&
            document.dispatchEvent) {
            var event_1 = document.createEvent('HTMLEvents');
            event_1.initEvent('resize', true, false);
            document.dispatchEvent(event_1);
        }
    };
    Breakpoints.prototype.componentWillUnmount = function () {
        if (this.handleDimensionEvent.eventAvailable) {
            this.handleDimensionEvent.removeDimensionEventListener();
        }
    };
    Breakpoints.prototype.render = function () {
        return (_jsx(BreakpointsProvider, __assign({ value: this.state }, { children: this.props.children }), void 0));
    };
    return Breakpoints;
}(React.Component));
export default Breakpoints;
